import { getConfigs } from 'core/config/index.js'
import { clearSlugAtCDA } from 'src/common/functions'
import { sentrySetUser } from 'src/common/sentry'
import { tokenService } from 'src/common/token-service'

const coreConfig = getConfigs()

export const userService = {
  async logout() {
    try {
      sentrySetUser(null)
    } catch (e) {
      console.error(e)
    }

    if (process.env.PLATFORM === 'olimpbet') {
      try {
        const response = await fetch('/api/logout', {
          method: 'POST',
          credentials: 'include',
        })
        if (!response.ok) {
          const text = await response.text().catch(() => '')
          console.error('Logout request failed', response.status, text)
        }
      } catch (err) {
        console.error('Logout request error', err)
      }
    }

    await tokenService.removeToken()
    localStorage.removeItem(coreConfig.CDA_KEY)

    if (!process.env.VUE_APP_CDA_URL) {
      return
    }

    return clearSlugAtCDA()
  },
}
